import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { toggleModal } from "@api/shared_screeners/modals"
import { updateSharedScreenerDates } from "@api/shared_screeners"
import DayPickerModal from "@src/helpers/dayPickerModal"

const ExpiryDate = ({ sharedScreener, updateSharedScreenerDates, toggleModal }) => (
  <DayPickerModal
    title={"Change availability and expiry dates for " + sharedScreener.shared_name}
    saveButtonText={"Update Availability and Expiry"}
    sharedScreener={sharedScreener}
    onSave={(availableAt, expiresAt, notifyReviewers) => updateSharedScreenerDates(sharedScreener._id, availableAt, expiresAt, notifyReviewers)}
    onClose={() => toggleModal("expiryDate")}/>
)

ExpiryDate.propTypes = {
  sharedScreener: PropTypes.object.isRequired,
  updateSharedScreenerDates: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = ({ shared_screeners }) => ({
  sharedScreener: shared_screeners.modals.expiryDate.sharedScreener
})

const mapDispatchToProps = dispatch => ({
  updateSharedScreenerDates: bindActionCreators(updateSharedScreenerDates, dispatch),
  toggleModal: bindActionCreators(toggleModal, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpiryDate)
